import { CustomerItem } from '../../../store/customer/types';
import { OrderData } from '../../../store/order/types';
import {
  ProductItem,
  SelectedProduct,
  StructuredOperationBillingTypeSelected,
} from '../../../store/product/types';
import { OperationType } from '../../BatchTicket/components/DynamicAsset/contexts/constants';

import { paramsRequestType, screenName } from './constants';

type ProductType = SelectedProduct['type'];

type EquityOrderTypeForApi = 'Limit' | 'Market';

export const serializeEquityOrderTypeForApi = (
  orderType: SelectedProduct['orderType']
): EquityOrderTypeForApi => (orderType === 'Market' ? 'Market' : 'Limit');

interface GetOrderServiceMethodProps {
  operationType?: OperationType;
}

type orderServiceMethodResponse = 'postOrdersSell' | 'postOrdersBuy';

interface PostOrderParamsProps {
  orderItem: OrderData;
  structuredOperationBillingOptionSelected: StructuredOperationBillingTypeSelected;
  isManager: boolean;
  productItem: ProductItem;
  productType: ProductType;
  customerItem: CustomerItem;
  productId: string;
  operationTypeIsSale?: boolean;
}

export const getOrderServiceMethod = ({
  operationType,
}: GetOrderServiceMethodProps): orderServiceMethodResponse => {
  const serviceMethod = operationType === 'sell' ? 'postOrdersSell' : 'postOrdersBuy';

  return serviceMethod || 'postOrdersBuy';
};

export const getOrderPostParams = (props: PostOrderParamsProps) => {
  const {
    orderItem,
    isManager,
    productItem,
    productType,
    customerItem,
    productId,
    operationTypeIsSale,
  } = props;

  const interactionChannelAudit = orderItem.interactionChannelAudit;

  const fixedIncomeParamsParams = {
    requestedOfferDetail: productItem.current.orderFee,
  };

  const fundsSellParams = {
    requestedDateQuotation: productItem.current.dateQuotation,
    scheduleDate: productItem.current.scheduleDate,
    isTotalWithdraw: productItem.current.isTotalRedemption,
  };

  const COEParams = {
    billingTypeId: Number(productItem.current.billingTypeId),
  };

  const equityParams = {
    orderType: serializeEquityOrderTypeForApi(productItem.current.orderType),
    orderPrice: productItem.current.orderValue,
  };

  const notificationChannels = orderItem?.channels || ['email'];

  const params = {
    [paramsRequestType[productType]]: {
      accountNumber: customerItem.current.accountNumber,
      productId,
      orderAmount: productItem.current.orderValue,
      orderName: orderItem.name,
      orderDescription: orderItem.description,
      notificationChannels,
      quantity: productItem.current.orderQuantity,
      ...(productType === 'FixedIncome' && fixedIncomeParamsParams),
      ...(productType === 'Equity' && equityParams),
      ...(productType === 'Fund' && operationTypeIsSale && fundsSellParams),
      ...(productType === 'StructuredOperations' && COEParams),
      ...(!isManager && { interactionChannelAudit }),
    },
    screenName,
  };

  return params;
};
